import { Button, Checkbox, ListItemText, MenuItem, Select, Typography } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import { AppStore } from "../../../../AppStore";
import { Form } from "../../../../components/form/FormElement";
import styles from "../styles/Components.css";
import { User, UserRole, UserRoleRender } from "../../../../services/user/models/User";
import { UserService } from "../../../../services/user/UserService";
import Loader from "react-spinners/BarLoader";
import { CompanyService } from "../../../../services/company/CompanyService";
import { Company } from "../../../../services/company/models/Company";

interface Props {
  onSubmit?: () => void;
}

export const AddUserForm: FunctionComponent<Props> = (props) => {
  const [state, actions] = AppStore.users.use();
  const [model] = useState(new User());
  const [loading, setLoading] = useState(false);

  // Portal admins add users from here and may place them in several
  // companies at once. Company admins use the form in the company area,
  // which assigns only the company being viewed.
  const [allCompanies, setAllCompanies] = useState<Company[]>([]);
  const [companyIds, setCompanyIds] = useState<string[]>([]);

  useEffect(() => {
    CompanyService.getAll()
      .then((results) => setAllCompanies(results ?? []))
      .catch(() => setAllCompanies([]));
  }, []);

  const handleSubmit = (user) => {
    setLoading(true)

    user.companyIds = companyIds;
    // companyId keeps older API builds working
    user.companyId = companyIds[0];

    return UserService.addOne(user)
      .then(actions.updateCollection)
      .then(props.onSubmit)
      .catch(console.log)
      .finally(() => {
        setLoading(false);
        setCompanyIds([]);
      })
  };

  return (
    <Form model={model} onSubmit={handleSubmit}>
      <Form.Item field="name">
        <Form.Input fullWidth placeholder="John Doe" label="Name" />
      </Form.Item>
      <Form.Item field="email">
        <Form.Input fullWidth placeholder="john@doe.com" label="Email" />
      </Form.Item>
      <Form.Item field="role">
        <Form.Dropdown
          options={Object.values(UserRole)}
          valueModifier={(value) => UserRoleRender[value]}
          defaultValue={UserRole.User}
          label="Role"
          placeholder="John Doe"
        />
      </Form.Item>
      <Form.Item field="companyIds">
        <div>
          <Typography variant="caption">Companies</Typography>
          <Select
            multiple
            displayEmpty
            fullWidth
            value={companyIds}
            onChange={(event) => setCompanyIds(event.target.value as string[])}
            renderValue={(selected) =>
              (selected as string[]).length === 0
                ? "None"
                : allCompanies
                    .filter((c) => (selected as string[]).includes(c.id))
                    .map((c) => c.name)
                    .join(", ")
            }
          >
            {allCompanies.map((company) => (
              <MenuItem key={company.id} value={company.id}>
                <Checkbox checked={companyIds.includes(company.id)} />
                <ListItemText
                  primary={company.name}
                  secondary={company.location}
                />
              </MenuItem>
            ))}
          </Select>
        </div>
      </Form.Item>
      <Form.Item field="submit">
        <div className={styles.submitButtonContainer}>
          {loading ?
          <Loader />
          :
          <Button variant="contained">Submit</Button>
        }
        </div>
      </Form.Item>
    </Form>
  );
};
